export class LoadPlaylistEvents {
  static readonly type = '[LoadPlaylistEvents] Load Playlist Events';

  constructor(readonly playlistSlug: string) {}
}
